import { useEffect, useRef, useState } from 'react';

const HEX = '0123456789ABCDEF';
const rndHex = (len: number) => Array.from({ length: len }, () => HEX[Math.floor(Math.random() * 16)]).join('');
const rndLine = () => {
  const kind = Math.floor(Math.random() * 4);
  if (kind === 0) return `0x${rndHex(8)}  MOV  R${Math.floor(Math.random() * 9)}, [0x${rndHex(4)}]`;
  if (kind === 1) return `PACKET ${rndHex(4)}:${rndHex(4)} → NODE-${Math.floor(Math.random() * 90 + 10)} OK`;
  if (kind === 2) return `checksum ${rndHex(16)} verified`;
  return `>> decrypt_block(${rndHex(6)}) :: ${Math.floor(Math.random() * 100)}%`;
};

/**
 * פרץ קוד כאוטי קצר (השראת pranx.com/hacker) לפני שהמסוף מתייצב לטקסט הקריא
 * והמכוון של רצף האתחול. עיצוב בלבד — לא תוכן קריטי, ולכן מוצג רק כש-Reduced
 * Motion כבוי ולכל היותר כ-~500ms (קצר מהמקור, לבקשת המשתמש).
 */
export function CodeBurst({ enabled, onDone }: { enabled: boolean; onDone: () => void }) {
  const [lines, setLines] = useState<string[]>(() => (enabled ? [rndLine(), rndLine(), rndLine()] : []));
  const doneRef = useRef(onDone);
  doneRef.current = onDone;

  useEffect(() => {
    if (!enabled) {
      doneRef.current();
      return;
    }
    const interval = setInterval(() => {
      setLines((prev) => [...prev.slice(-2), rndLine()]);
    }, 45);
    const timeout = setTimeout(() => {
      clearInterval(interval);
      doneRef.current();
    }, 500);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [enabled]);

  if (!enabled) return null;
  return (
    <div className="term-text code-burst mono" aria-hidden="true">
      {lines.map((l, i) => (
        <div key={i} className="term-line term-line--system code-burst__line">
          {l}
        </div>
      ))}
    </div>
  );
}
